import DOMPurify from 'dompurify';
import { Tooltip } from 'tdesign-react';

import { Question, RequiredIcon } from '@/components/icon';

import styles from './index.module.less';

interface IProps {
  required?: boolean;
  pageId?: string;
  tipList?: any[];
  moduleId?: string;
}

export const EasyTip = ({ required = false, pageId, moduleId, tipList }: IProps) => {
  const createMarkup = (html: string) => ({ __html: DOMPurify.sanitize(html) });

  let tipIcon = null;
  const tipText = null;
  let singleText = tipIcon ? null : tipText;
  let richText = tipIcon ? tipText : null;
  let custom: string | null = null;
  let btnText = null;

  if (pageId) {
    if (Array.isArray(tipList) && tipList.length > 0) {
      const matchedTip = tipList.find((tip: any) => tip
        && tip.pageId === pageId && moduleId === tip.moduleId);
      if (matchedTip) {
        ({ hasIcon: tipIcon, singleText, richText, custom, btnText } = matchedTip);
      }
    }
  }

  const showTooltip = !!tipIcon && (!!custom || (!!richText && richText !== '<p></p>'));

  const getTooltipContent = () => {
    if (custom) {
      return <div dangerouslySetInnerHTML={createMarkup(custom)} />;
    }
    if (richText && richText !== '<p></p>') {
      return <div dangerouslySetInnerHTML={createMarkup(richText)} />;
    }
    return null;
  };

  return (
    <div className={styles.container}>
      {required && <span style={{ marginLeft: 4 }}><RequiredIcon /></span>}

      {singleText && <span className={styles.singleText}>{singleText}</span>}

      {showTooltip && <Tooltip
        content={getTooltipContent()}
        destroyOnClose
        showArrow
        theme="default"
        placement='top-right'
        overlayClassName={custom ? styles.customTooltip : undefined}
        overlayInnerStyle={{ maxWidth: 680 }}
      >
        {btnText
          ? <div className={styles.textTip}>
              <Question className={styles.question} />
              <div>{btnText}</div>
            </div>
          : <Question className={styles.question} />
        }
      </Tooltip>}
    </div>
  );
};
